import React from 'react';
import { GraduationCap, Play, FileText, ExternalLink } from 'lucide-react';
interface GuideItem {
  id: string;
  title: string;
  description: string;
  type: 'Video' | 'Guide' | 'Article';
  url?: string;
}
const GUIDES: GuideItem[] = [{
  id: '1',
  title: 'Onboarding a PM Company',
  description: 'Learn how to integrate a new property management firm into your LawVo ecosystem.',
  type: 'Video'
}, {
  id: '2',
  title: 'Offboarding & Archiving Companies',
  description: 'Safely remove a PM company and manage their historical data within the platform.',
  type: 'Video'
}, {
  id: '3',
  title: 'Setting Up Knowledge Center',
  description: "Configure your group's Knowledge Center to centralize documents and resources.",
  type: 'Guide'
}, {
  id: '4',
  title: 'Using LawVo AI for Your Group',
  description: "Get the most out of LawVo AI by training it on your group's specific documents and policies.",
  type: 'Article'
}];
export function SuccessHubWidget() {
  const getTypeBadge = (type: GuideItem['type']) => {
    switch (type) {
      case 'Video':
        return <span className="inline-flex items-center gap-1 text-xs font-medium text-violetBlue" data-id="element-389">
            <Play className="w-3 h-3" data-id="element-390" />
            Video
          </span>;
      case 'Guide':
        return <span className="inline-flex items-center gap-1 text-xs font-medium text-turquoise" data-id="element-391">
            <FileText className="w-3 h-3" data-id="element-392" />
            Guide
          </span>;
      case 'Article':
        return <span className="inline-flex items-center gap-1 text-xs font-medium text-secondary" data-id="element-393">
            <ExternalLink className="w-3 h-3" data-id="element-394" />
            Article
          </span>;
    }
  };
  return <div className="bg-white border border-borderColor rounded-xl p-6 shadow-sm" data-id="element-395">
      {/* Header */}
      <div className="mb-6" data-id="element-396">
        <div className="flex items-center gap-3 mb-2" data-id="element-397">
          <div className="p-2.5 bg-aliceBlue rounded-lg" data-id="element-398">
            <GraduationCap className="w-5 h-5 text-violetBlue" data-id="element-399" />
          </div>
          <h3 className="text-xl font-semibold text-primary" data-id="element-400">
            LawVo Success Hub
          </h3>
        </div>
        <p className="text-sm text-secondary leading-relaxed pl-[52px]" data-id="element-401">
          Master the platform with step-by-step walkthroughs and guides designed
          to accelerate your workflow.
        </p>
      </div>

      {/* Guides List */}
      <div className="space-y-1" data-id="element-402">
        {GUIDES.map((guide, index) => <div key={guide.id} data-id="element-403">
            {index > 0 && <div className="border-t border-borderColor mx-1" data-id="element-404" />}
            <button onClick={() => console.log(`Opening guide: ${guide.id}`)} className="w-full text-left py-4 px-3 group hover:bg-aliceBlue rounded-lg transition-colors" data-id="element-405">
              <div className="flex items-start justify-between gap-3" data-id="element-406">
                <div className="flex-1 min-w-0" data-id="element-407">
                  <h4 className="text-sm font-semibold text-primary mb-1 group-hover:text-violetBlue transition-colors" data-id="element-408">
                    {guide.title}
                  </h4>
                  <p className="text-sm text-secondary leading-relaxed" data-id="element-409">
                    {guide.description}
                  </p>
                </div>
                <div className="flex-shrink-0 mt-0.5" data-id="element-410">
                  {getTypeBadge(guide.type)}
                </div>
              </div>
            </button>
          </div>)}
      </div>
    </div>;
}